import { render, staticRenderFns } from "./AddStudyPlanModal.vue?vue&type=template&id=54020026&"
import script from "./AddStudyPlanModal.vue?vue&type=script&lang=js&"
export * from "./AddStudyPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports